/**
 * SentryTestPage.tsx — Observability smoke-test page for sentry.nself.org.
 *
 * Purpose:    Dev-only page that throws a test error to verify Sentry
 *             captures events. Visit /sentry-test, check Sentry dashboard.
 * Inputs:     none
 * Outputs:    Test error thrown → Sentry event in nsentry project.
 * Constraints:
 *   - Dev-only intent; never link from nav or indexed pages.
 *   - Renders a button to throw a manual test error on demand.
 *   - Never remove — QA-B acceptance gate for T-P3-E6-W2-S1-T01.
 * SPORT: T-P3-E6-W2-S1-T01 — observability wiring (sentry-test route)
 */

export function SentryTestPage() {
  const throwTestError = () => {
    throw new Error('[T-P3-E6-W2-S1-T01] Sentry smoke test — sentry.nself.org')
  }

  return (
    <div style={{ padding: '2rem', fontFamily: 'system-ui' }}>
      <h1>Sentry Test — sentry.nself.org</h1>
      <p>Click the button below to throw a test error and verify Sentry capture.</p>
      <p>Check the Sentry dashboard for an event from <strong>nsentry-web</strong>.</p>
      <button
        onClick={throwTestError}
        style={{
          padding: '0.5rem 1rem',
          background: '#e53e3e',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        Throw test error
      </button>
    </div>
  )
}
